import { Component } from '@angular/core';
import { ResearchMemberRecommendationEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Member Recommendations') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-researchmemberrecommendation-form',
    templateUrl: './researchmemberrecommendation.form.component.html'
})
export class ResearchMemberRecommendationFormComponent extends BaseFormComponent {
    public record!: ResearchMemberRecommendationEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

